import { getContext, setContext } from 'svelte';

export interface DeviceViewStateContext {
	showMandatoryUpdateAlert: boolean;
}

const CONTEXT_KEY = Symbol('device-view-state');

export const setDeviceViewStateContext = (context: DeviceViewStateContext) => {
	setContext(CONTEXT_KEY, context);
};

export const getDeviceViewStateContext = (): DeviceViewStateContext | undefined => {
	return getContext<DeviceViewStateContext>(CONTEXT_KEY);
};

export const shouldHideLabelsAndCharts = (): boolean => {
	return getDeviceViewStateContext()?.showMandatoryUpdateAlert === true;
};
